import TextController from './TextController';
export default TextController;
